import { PROBATE_TASK_IDS } from "@/pages/postloss/probate/tasks";
import { useEstateTaskAnswers } from "@/shared/hooks/useEstateTaskAnswers";

export function useProbateTaskAnswers(estateId: number | undefined) {
  return useEstateTaskAnswers(estateId, PROBATE_TASK_IDS, "probate");
}
